'use strict';/* global define:false */define('modules/feedback/states/team_overview/index',['require','text!./template.html'],function(require){'use strict';/**
   * Define the data restriction based on the roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object}   ROLES     - Definition of the possible roles.
   *
   * @return {Object}            - Resolves promise for roleCheck.
   */function restricted(roleCheck,ROLES){return roleCheck.promise(ROLES.supervisor,ROLES.wannabe);}/**
   * Verify the provided roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object}   ROLES     - Definition of the possible roles.
   *
   * @return {Boolean}           - Boolean indicating whether user has specified
   *                               roles or not.
   */function menu(roleCheck,ROLES){return roleCheck(ROLES.supervisor,ROLES.wannabe);}return{url:'/feedback-overview/:tab',views:{'body@app':{template:require('text!./template.html')}},params:{tab:{value:null,squash:true}},data:{restricted:restricted},meta:{label:'GIVING_FEEDBACK.LABEL',icon:'&#xE400;',menu:menu,order:1}};});
